var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "filter-control service-filters"
  }, [_vm.getRole() === 'alex_admin' ? _c('filter-by-employee', {
    attrs: {
      "label": 'bankár',
      "employees": _vm.brokersGetter
    },
    on: {
      "employee-filter-change": function employeeFilterChange($event) {
        return _vm.$emit('broker-filter-change', $event);
      }
    }
  }) : _vm._e(), _c('search-by-key', {
    on: {
      "filter-client-by-key": function filterClientByKey($event) {
        return _vm.$emit('filter-client', $event);
      }
    }
  }), _c('div', {
    staticClass: "service-view-switch",
    attrs: {
      "role": "group",
      "aria-label": "Zobrazenie klientov v Servise"
    }
  }, [_c('button', {
    "class": {
      'is-active': !_vm.opportunitiesOnly
    },
    attrs: {
      "type": "button",
      "aria-pressed": !_vm.opportunitiesOnly
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('opportunity-filter-change', false);
      }
    }
  }, [_vm._v("Všetci")]), _c('button', {
    "class": {
      'is-active': _vm.opportunitiesOnly
    },
    attrs: {
      "type": "button",
      "aria-pressed": _vm.opportunitiesOnly,
      "title": "Klienti s možnou úsporou aspoň 20 € mesačne"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('opportunity-filter-change', true);
      }
    }
  }, [_vm._v("S úsporou "), _c('span', [_vm._v("20 €+/mes.")])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }